module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABUklEQVRIS8WVsU6DUBiFz6H26mziJqSJTaD6CA7qZrp3cNC4GuMztD6EmvgAmuhq0rFOvoEpxqmwmPgEQuQ3ECEFpVwGlInAud89Of/lQJRc085Kx4iioQDHZZofz0XeAdw7fnjKskUvlhpGkBMDvNIFC7AB4LAl7JaCXbM9Ifloe8G5LjjWuZYSiaK95sCupQYE+iLSqeMs1gpx2/PC6/l1meOpqW5I7BDICXQ2EWBEsm/PPsapPgPHNwRGdbNM8vxlDn8LfrXU5qfIxcIYSN/xgqNajhsD6wwsdwL+PePndawuGeqsynl6grRPhU7GYvCtNwsOag2vymnxvbbjRsFxXVZtUMw41Se1KbLfWg67nP+k40ICcFcBfnK8YDvNGORupheMCXmw/fAyB65yqpNxqmkQbLYnSbeK1PpT0DDW4tiKtZk5/h7WQICtulEsqtsvBaE7VxiS6ccAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/copy.png
// module id = mnGE
// module chunks = 18